import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";

export default function Login() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => console.error(e));
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
            <rect width="52" height="52" rx="14" fill="#230658" />
            <path
              d="M16 26L23 33L36 19"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1>Employee Lifecycle Portal</h1>
        <p className="login-subtitle">
          Sign in with your Insomnia Cookies account to manage employee
          onboarding and offboarding.
        </p>
        <button className="btn-primary login-btn" onClick={handleLogin}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M6 10h8M11 7l3 3-3 3"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Sign in with Microsoft
        </button>
        <p className="login-hint">Use your @insomniacookies.com account</p>
      </div>
    </div>
  );
}
